module.exports = __webpack_public_path__ + "static/img/banner.d82801d.png";


//////////////////
// WEBPACK FOOTER
// ./static/m/banner.png
// module id = RSZb
// module chunks = 7